<template>
  <PublicView>
    <main v-if="product" style="text-align: left">
      <div class="shop-item-single py-120">
        <div class="container">
          <div class="row">
            <div class="col-lg-5">
              <div class="item-gallery mb-5">
                <div
                  class="flex-viewport"
                  style="overflow: hidden; position: relative"
                >
                  <img :src="previewImg" alt="" />
                </div>
                <div
                  class="flexslider-thumbnails pt-3"
                  v-if="product.images.length > 1"
                >
                  <swiper
                    @swiper="setThumbsSwiper"
                    :spaceBetween="10"
                    :slidesPerView="'auto'"
                    :freeMode="true"
                    :watchSlidesProgress="true"
                    :modules="modules"
                    class="mySwiper"
                  >
                    <swiper-slide
                      v-for="i in product.images"
                      :key="i"
                      v-on:click="previewImg = i"
                    >
                      <img :src="i" />
                    </swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="single-item-info" style="text-align: left">
                <h4 class="single-item-title">{{ product.name }}</h4>
                <div class="single-item-price">
                  <h4>
                    <span v-if="price != -1">{{ numberFormat(price) }}</span>
                    <span v-if="price == -1">(Liên hệ)</span>
                  </h4>
                </div>
                <p class="mb-4">
                  {{ product.shortDescription }}
                </p>
                <div class="single-item-content">
                  <h5>Trạng thái: <span>Còn hàng</span></h5>
                </div>
                <div class="single-item-action">
                  <h5 class="title">Quantity:</h5>
                  <div class="cart-qty">
                    <button class="minus-btn">
                      <i class="fal fa-minus"></i>
                    </button>
                    <input class="quantity" type="text" value="1" disabled="" />
                    <button class="plus-btn">
                      <i class="fal fa-plus"></i>
                    </button>
                  </div>
                  <div class="item-single-btn-area">
                    <button class="theme-btn">
                      <span class="far fa-shopping-cart"></span> Add to cart
                    </button>
                  </div>
                </div>
                <div class="single-item-content">
                  <h5>
                    Dành cho:
                    <span>{{
                      version(
                        product.year,
                        product.make + " " + product.model + " "
                      )
                    }}</span>
                  </h5>
                </div>
                <div
                  class="single-item-content d-flex mb-3"
                  style="column-gap: 10px; row-gap: 10px; flex-wrap: wrap"
                  v-if="
                    product.productOption && product.productOption.materials
                  "
                >
                  <h5 style="margin-top: 8px">Chất liệu:</h5>
                  <button
                    type="button"
                    class="btn"
                    v-for="m in product.productOption.materials"
                    :key="m"
                    v-bind:class="{
                      'btn-light': m != material,
                      'theme-btn': m == material,
                    }"
                    v-on:click="selectMaterial(m)"
                  >
                    {{ m.name }}
                  </button>
                </div>
                <div
                  class="single-item-content"
                  v-if="product.productOption && product.productOption.colors"
                  style="display: flex"
                >
                  <h5>Màu sắc:</h5>
                  <div class="colors" style="padding-left: 10px">
                    <div
                      v-for="c in colors"
                      :key="c.name"
                      class="color"
                      :title="c.name"
                      :style="styleColor(c.color)"
                      v-bind:class="{ select: c.name == color }"
                      v-on:click="selectColor(c)"
                    >
                      <div class="line" :style="styleColor(c.color2)"></div>
                    </div>
                  </div>
                </div>
                <div
                  class="single-item-content"
                  v-if="material && color"
                  style="display: flex"
                >
                  <img
                    style="width: 80px; height: auto"
                    :src="mic"
                    v-for="mic in materialImg"
                    :key="mic"
                    alt=""
                  />
                </div>

                <hr />
                <div class="single-item-share">
                  <span>Share:</span>
                  <a href="#"><i class="fab fa-facebook-f"></i></a>
                  <a href="#"><i class="fab fa-twitter"></i></a>
                  <a href="#"><i class="fab fa-instagram"></i></a>
                  <a href="#"><i class="fab fa-linkedin-in"></i></a>
                  <a href="#"><i class="fab fa-pinterest-p"></i></a>
                </div>
              </div>
            </div>
          </div>
          <div class="single-item-details">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  class="nav-link active"
                  id="nav-tab1"
                  data-bs-toggle="tab"
                  data-bs-target="#tab1"
                  type="button"
                  role="tab"
                  aria-controls="tab1"
                  aria-selected="true"
                >
                  Description
                </button>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div
                class="tab-pane fade show active"
                id="tab1"
                role="tabpanel"
                aria-labelledby="nav-tab1"
              >
                <div
                  class="single-item-desc"
                  v-html="product.description"
                ></div>
              </div>
            </div>
          </div>
          <div class="related-item" v-if="lsProduct.length > 0">
            <div class="row">
              <div class="col-12 mx-auto">
                <div class="site-heading">
                  <h2 class="site-title">Sản phẩm liên quan</h2>
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div
                class="col-md-6 col-lg-3"
                v-for="p in lsProduct"
                :key="p._id"
              >
                <div class="shop-item">
                  <div class="shop-item-img">
                    <span class="shop-item-sale">Sale</span>
                    <img :src="p.avatar" alt="" />
                  </div>
                  <div class="shop-item-info">
                    <router-link :to="productLink(p._id, p.alias)"
                      ><h4 class="shop-item-title">
                        {{ p.name }}
                      </h4></router-link
                    >
                    <div class="shop-item-price">
                      {{ numberFormat(p.price) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </PublicView>
</template>
<style lang="less">
.flexslider-thumbnails {
  .swiper {
    .swiper-wrapper {
      .swiper-slide {
        width: 80px;
      }
    }
  }
}
.single-item-desc {
  p:empty {
    height: 1.5em;
  }
}
.single-item-content {
  .colors {
    display: flex;
    column-gap: 8px;
    .color {
      height: 25px;
      width: 25px;
      border-radius: 25px;
      display: flex;
      justify-content: center;
      overflow: hidden;
      &.select {
        border: 2px solid #2db7ff;
      }
      .line {
        height: 25px;
        width: 2px;
        transform: rotate(45deg);
      }
    }
  }
}
</style>
<script>
import PublicView from "@/components/PublicView.vue";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper";
export default {
  data() {
    return {
      previewImg: "",
      material: null,
      color: null,
    };
  },
  methods: {
    selectColor(c) {
      this.color = c.name;
    },
    selectMaterial(m) {
      this.material = m;
      if (this.color) {
        let colorCheck = this.material.colors.find((i) => i.name == this.color);
        if (!colorCheck) {
          this.color = null;
        }
      }
    },
    styleColor(c) {
      return "background: " + c;
    },
    version(year, pre = "") {
      let result = [];
      for (let i = 0; i < year.length; i++) {
        let text = year[i].year;
        let vers = [];
        for (let ver in year[i].versions) {
          vers.push(year[i].versions[ver].v);
        }
        if (vers.length > 0) {
          result.push(vers.map((i) => pre + i + " " + text).join(", "));
        } else {
          result.push(text);
        }
      }
      return result.length > 0 ? result.join(", ") : "";
    },
    productLink(id, alias) {
      return "/san-pham/" + alias + "/" + id;
    },
    numberFormat(num) {
      return new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
      }).format(num);
    },
  },
  mounted() {
    console.log(this.product);
    if (
      this.product &&
      Array.isArray(this.product.images) &&
      this.product.images.length > 0
    ) {
      this.previewImg = this.product.images[0];
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    PublicView,
  },
  computed: {
    materialImg() {
      let colorCheck = this.material.colors.find((i) => i.name == this.color);
      if (colorCheck) {
        return colorCheck.images;
      } else {
        return [];
      }
    },
    price() {
      if (this.product) {
        if (this.material) {
          return this.product.price + this.material.addPrice;
        } else {
          return this.product.price;
        }
      } else {
        return -1;
      }
    },
    colors() {
      if (this.material) {
        return this.material.colors;
      }
      if (this.product && this.product.productOption) {
        return this.product.productOption.colors;
      } else {
        return [];
      }
    },
    product() {
      let product = this.$store.getters.product(this.$route.params.id);
      if (product) {
        document.querySelector("title").innerText =
          "Azzura.vn - " + product.seoData.title;
      }
      return product;
    },
    lsProduct() {
      if (this.product) return this.$store.getters.lsProduct(this.product);
      return [];
    },
  },
  watch: {
    product(v) {
      if (Array.isArray(v.images) && v.images.length > 0) {
        this.previewImg = v.images[0];
      }
    },
  },
  setup() {
    const setThumbsSwiper = (swiper) => {
      console.log(swiper);
    };

    return {
      setThumbsSwiper,
      modules: [FreeMode, Navigation, Thumbs],
    };
  },
};
</script>